import React from 'react';

const Lighthouse = () => {
  return <div className="lighthouse"></div>;
};

export default Lighthouse;
